'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateConfig = exports.createCallable = exports.getEventsFromInput = undefined;

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _events = require('./events');

Object.defineProperty(exports, 'getEventsFromInput', {
  enumerable: true,
  get: function get() {
    return _events.getEventsFromInput;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createCallable = exports.createCallable = function createCallable(f) {
  return (0, _isFunction3.default)(f) ? f : function () {
    return f;
  };
};

var validateConfig = exports.validateConfig = function validateConfig(config) {
  var requiredProps = ['databaseURL', 'authDomain', 'apiKey'];
  requiredProps.forEach(function (p) {
    if (!config[p]) {
      throw new Error(p + ' is a required config parameter for react-redux-firebase.');
    }
  });

  var functionProps = ['fileMetadataFactory', 'profileDecorator', 'onAuthStateChange'];

  functionProps.forEach(function (p) {
    if (!!config[p] && !(0, _isFunction3.default)(config[p])) {
      throw new Error(p + ' parameter in react-redux-firebase config must be a function. check your compose function.');
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-firebase/es/utils/index.js
// module id = 351
// module chunks = 0